import React from 'react';
import { Button, CustomFlowbiteTheme } from 'flowbite-react';

import Copy from '@/components/commons/icons/Copy';

function CopyButton({
    onClick,
    disabled = false,
}) {
    const customButtonTheme: CustomFlowbiteTheme['button'] = {
        base: 'group w-full sm:w-auto flex h-min items-center justify-center text-center font-medium relative focus:z-10 focus:outline-none min-h-[37px]',
        color: {
            // TODO: Update focus/hover values - they are identical to background color
            light: 'text-gray-900 bg-cirrusWhite border border-gray-300 enabled:hover:bg-gray-100 focus:ring-4 focus:ring-cyan-300 dark:bg-gray-600 dark:text-cirrusWhite dark:border-gray-600 dark:enabled:hover:bg-gray-700 dark:enabled:hover:border-gray-700 dark:focus:ring-gray-700',
        },
        size: {
            md: 'text-sm px-3 py-2',
        },
    };
    return (
        <Button
            onClick={onClick}
            theme={customButtonTheme}
            color="light"
            size="md"
            disabled={disabled}
            isProcessing={disabled}
        >
            <div className="flex gap-2 jusify-center items-center w-full h-full">
                <Copy className="ml-1 mr-1 h-3 w-3" />
                <span className="text-cleanSlate font-instrument text-base font-bold leading-150">Copy</span>
            </div>
        </Button>
    );
}

export default CopyButton;
